import { useUserStore, useChatStore } from '@/store'
import { HttpService } from '../services'
const http = new HttpService(
  'https://59eqqs42ya.execute-api.us-east-1.amazonaws.com/PROD/ai/message'
)

type AgentResponse = {
  text: string
  messages: any[]
}

type AgentInput = {
  input: string
  context: any
}

export async function useAgent(inputText: string) {
  try {
    const { user } = useUserStore()
    const { setContext, context } = useChatStore()
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${user?.idToken}`,
    }

    const { data } = await http.post<AgentInput, AgentResponse>(
      '',
      { input: inputText, context },
      { headers }
    )

    console.log('Agent response:', JSON.stringify(data, null, 2))
    setContext(data.messages)
    return data.text
  } catch (error) {
    console.error('Error in useAgent:', error)
    throw new Error('Failed to get agent response')
  }
}
